// extracted by mini-css-extract-plugin
module.exports = {"container":"PopupMenu_container__3BEdo","menu-item":"PopupMenu_menu-item__3RKBa"};